import React from 'react';

// ดัก error ตอน render (ที่ dialog/interceptor ดักไม่ได้ เพราะไม่ใช่ promise) กัน production
// ขึ้นจอขาวทั้งหน้า — mount ครอบทั้งแอปที่ index.js
class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('GlobalErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            gap: 12,
            fontFamily: 'inherit',
            padding: 24,
            textAlign: 'center',
          }}
        >
          <div style={{ fontSize: '1.1rem', fontWeight: 700, color: '#d32f2f' }}>
            เกิดข้อผิดพลาดที่ไม่คาดคิด
          </div>
          <div style={{ color: '#6b7280', fontSize: '0.9rem' }}>
            กรุณารีเฟรชหน้านี้ใหม่ หากยังพบปัญหาให้แจ้งทีมพัฒนา
          </div>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              marginTop: 8,
              padding: '8px 20px',
              borderRadius: 4,
              border: 'none',
              background: '#1976d2',
              color: '#fff',
              cursor: 'pointer',
              fontSize: '0.9rem',
            }}
          >
            รีเฟรชหน้า
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default GlobalErrorBoundary;
